import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 12h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 12h2v8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 20h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 20h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Ligature";
const Ligature = memo(themed(Icon));
export {
  Ligature
};
//# sourceMappingURL=ligature.js.map
